<div class="row form-group">
  <div class="col-lg-5 col-md-12 col-sm-12 col-12">
    <div class="row payment-breakdown m-b-25">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <h3 class="text-bold">Total Payment Today</h3>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <h3 class="text-bold pull-right">
            ${{financeData.payable_amount_today || 0|DynamicDecimalPipe:mainService.currency_data.currency_code}}</h3>
        </div>
      </div>
      <div class="row lighten-text">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Down Payment</div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6"><span
            class=" pull-right">${{financeData.downpayment_amount||'0'|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
        </div>
      </div>
      <div class="row lighten-text">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" *ngIf="contract_type==1">First Recurring Payment</div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" *ngIf="contract_type==2 || contract_type==4">Upfront Payment
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6"><span
            class=" pull-right">${{financeData.advance_interest_amount||'0'|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
        </div>
      </div>
      <div class="row lighten-text">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Enrollment Fee</div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6"><span
            class=" pull-right">${{financeData.fixed_flat_fee||'0'|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
        </div>
      </div>
      <div class="row lighten-text">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" *ngIf="contract_type ==2">Transaction Fee<i
            class="fa fa-info-circle m-l-5" placement="right"
            tooltip="A Transaction fees is only applied to down payment and upfront payment."></i></div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" *ngIf="contract_type ==1">Transaction Fee<i
            class="fa fa-info-circle m-l-5" placement="right"
            tooltip="A Transaction fees is only applied to down payment and first recurring payment."></i></div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6"><span
            class=" pull-right">${{financeData.transaction_fee||'0'|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
        </div>
      </div>
    </div>
    <h4 class="m-t-30 col-lg-12 col-md-12 col-sm-12 col-12">Choose when your payments will start :</h4>
    <div class="row p-l-15 p-r-15">
      <div class="col-lg-6">
        <div class="input-group">
          <input readonly class="form-control" placeholder="Select Date" [bsConfig]="bsConfig"
            [(ngModel)]="recurringDate" #rec="bsDatepicker" bsDatepicker [minDate]="minDate" [maxDate]="maxDate"
            [readOnly]="false">
          <div class="input-group-prepend" (click)="rec.toggle()" [attr.aria-expanded]="rec.isOpen">
            <span class="input-group-text" id="inputGroupPrepend3"><i class="fa fa-calendar"></i></span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row p-l-15 p-r-15">
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
        <select name="month" class="form-control" [(ngModel)]="dob.month">
          <option value="">Month</option>
          <option *ngFor="let month of months">
            {{month.month_name}}
          </option>
        </select>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
        <select name="date" class="form-control" [(ngModel)]="dob.date">
          <option value="">Date</option>
          <option *ngFor="let date of dates">
            {{date}}
          </option>
        </select>

      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
        <select name="year" class="form-control" [(ngModel)]="dob.year">
          <option value="">Year</option>
          <option *ngFor="let year of newYears">
            {{year}}
          </option>
        </select>

      </div>
    </div> -->
    <div class="p-15 form-group">
      <h4 class="m-t-30 col-lg-12 col-md-6 col-sm-12 col-12 p-l-0">{{LABEL.Patient}}'s Signature :</h4>
      <div class="p-0" #canvasDiv id="canvasDiv" style="border: solid 1px #dce5eb;height: 300px;width: 100%">
        <!-- <signature-pad style="display:table" [options]="signaturePadOptions" (onEndEvent)="drawComplete()"></signature-pad> -->
        <app-signature-pad (signatureSaved)="drawComplete($event)"
          [parentWidth]="getParentDivWidth()"></app-signature-pad>
      </div>
    </div>
    <div class="p-15">
      <button class="btn btn-secondary whiteBtn" (click)="clearSign()">Clear</button>
      <p *ngIf="signature" style="margin: 10px;display: inline-block;">Signature Registered</p>
    </div>
  </div>
  <div class="col-sm-12 col-xs-12 col-md-12 col-lg-7">
    <div class="col">
      <ng-container *ngIf="patientData.payment_sources.length==0; else elseTemplate">
        <div class="col-lg-12">
          <h4 class="m-t-30 col-lg-12 col-md-6 col-sm-12 col-12">No card added yet for {{LABEL.patient}}</h4>
          <div class="row justify-content-end p-15">
            <button class="btn btnDefault pull-right" (click)="GetStripeToken('clear');addCardModal.show();">Add
              Card</button>
          </div>
          <!-- <div class="row p-15">
              <label *ngIf="patient_new_stripe_token !== undefined">New card selected</label>
            </div> -->
        </div>
      </ng-container>
      <ng-template #elseTemplate>
        <div class="card card-body m-t-30">
          <h4>{{LABEL.Patient}}'s Cards</h4>
          <div class="table-responsive" style="max-height: 400px;overflow-y:auto">
            <table class="table table-striped table-hover table-vmiddle">
              <thead>
                <tr>
                  <th class="smallTD">S.No.</th>
                  <th class="largerTD">Card No</th>
                  <th class="normalTD">Brand</th>
                  <th class="smallTD text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of patientData.payment_sources;let i=index;">
                  <td class="smallTD">{{i+1}}</td>
                  <td class="largerTD">XXXX-XXXX-XXXX-{{data.last4}}</td>
                  <td class="normalTD">{{data.brand}}</td>
                  <td class="smallTD text-center">
                    <button class="btn btnDefault" (click)="selectCard(data,i)"
                      *ngIf="i != selectedCardIndex">Select</button>
                    <label for="" *ngIf="i== selectedCardIndex">Selected</label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- *ngIf="patient_new_stripe_token === undefined"  -->
          <div class="row justify-content-end p-15">
            <button class="btn btnDefault pull-right" (click)="GetStripeToken('clear');addCardModal.show()">Add
              Card</button>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<div class="row form-group">
  <div class="col">
    <p style="display: block" *ngIf="!(financeData.advance_interest_amount && contract_type == 1)">You will be on this
      contract for {{financeData.number_of_payments}} month(s) provided all
      payments are made as
      agreed by you on this contract.</p>
    <p style="display: block" *ngIf="financeData.advance_interest_amount && contract_type == 1">You will be on this
      contract for {{financeData.number_of_payments - 1}} month(s) provided all
      payments are made as
      agreed by you on this contract.</p>
    <div class="checkbox" style="display: block">
      <label style="color:#505050">
        <input type="checkbox" value="" [(ngModel)]="terms">
        <i class="input-helper"></i>
        I’ve read & agree with all <a style="color: #017A9F !important;"> target="_blank" [routerLink]="['/terms']"
          routerLinkActive="router-link-active" >Terms
          & Conditions</a>.
      </label>
    </div>
    <div class="checkbox" style="display: block">
      <label style="color:#505050">
        <input type="checkbox" value="" [(ngModel)]="consent">
        <i class="input-helper"></i>
        I've read and agreed to the <a style="color: #017A9F !important;"> target="_blank"
          [routerLink]="['/consentForm']" routerLinkActive="router-link-active" >Consent for {{LABEL.Treatment}} &
          Payment Plan Agreement</a>.
      </label>
    </div>

  </div>
  <div class="col">
    <div class="p-t-20 p-b-20 d-flex justify-content-center">
      <button class="btn btnDefault" style="max-width:400px; width: 75%; border-radius: 50px" type="button"
        (click)="validateData()">Submit</button>
    </div>
  </div>
</div>
<div bsModal #askRecurringCardModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md  modal-dialog-centered customModal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Card for Recurring Payments</h4>
        <button type="button" class="close" aria-label="Close" (click)="askRecurringCardModal.hide()">&times;</button>
      </div>
      <div class="modal-body">
        <p>Do you want to use same card to pay the recurring payments?</p>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-6 text-start">
            <button type="button" class="btn btn-outline-secondary" (click)="resetRecurringModal();">No</button>
          </div>
          <div class="col-6 text-end">
            <button class="btn btn-primary" (click)="downPaymentAsRecurring();">Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div bsModal #addRecurringCardModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
  (onShow)="AddStripeElement('recursive_add_card')" aria-labelledby="mySmallModalLabel" aria-hidden="true"
  (onHide)="RemoveStripeElement('recursive_add_card')">
  <div class="modal-dialog  modal-dialog-centered customModal"
    [ngClass]="{'modal-xl': patientData.recurring_payment_sources.length > 0,'modal-md': patientData.recurring_payment_sources.length == 0}">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add/Select Card for Recurring Payments</h4>
        <button type="button" class="close" aria-label="Close"
          (click)="addRecurringCardModal.hide();removeValues();">&times;</button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5"
            [ngClass]="{'col-5': patientData.recurring_payment_sources.length > 0,'col-12': patientData.recurring_payment_sources.length == 0}">
            <app-generate-stripe-token [address]="{address_1: patientData?.patient_address,
                  city: patientData?.city, state: patientData?.state_name, zip: patientData.zip, type: 'patient'}"
              [buttonClickedSubject]="buttonClickedSubject" [elementId]="'recursive_add_card'"
              (cardResponse)="CatchStripeTokenForRecursiveCard($event)" *ngIf="patientData" class="col-12"
              [show_save_card]="false"></app-generate-stripe-token>
          </div>
          <div class="col-2 VHAlign text-center" *ngIf="patientData.recurring_payment_sources.length > 0">
            OR
          </div>
          <div class="col-5" *ngIf="patientData.recurring_payment_sources.length > 0">
            <label>Select from previously added cards</label>
            <div style="max-height: 600px;overflow-y: auto">
              <div *ngFor="let item of patientData.recurring_payment_sources">
                <div class="p-15 cardDiv">
                  <p class="m-0 col-9" style="display:flex;align-items: center"><i
                      class="fa fa-credit-card lightGreyIcon"></i>&nbsp;&nbsp;XXXX-XXXX-XXXX-{{item.last4}}</p>
                  <div class="col-3 p-0 text-end">
                    <a (click)="selectRecurringCard(item)" [class.disabled]="hitInProgress"
                      class="pull-right">Select</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-6 text-start">
            <button type="button" class="btn btn-outline-secondary"
              (click)="addRecurringCardModal.hide()">Cancel</button>
          </div>
          <div class="col-6 text-end">
            <button class="btn btn-primary" [disabled]="hitInProgress"
              (click)="GetStripeToken('add_recurring_card')">Add</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div bsModal #addCardModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
  aria-hidden="true" [config]="{backdrop: 'static'}" (onShow)="AddStripeElement('add_card')"
  (onHide)="RemoveStripeElement('add_card')">
  <div class="modal-dialog modal-md modal-dialog-centered customModal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add Card</h4>
        <button type="button" class="close" aria-label="Close" (click)="addCardModal.hide()">&times;</button>
      </div>
      <div class="modal-body">
        <app-generate-stripe-token [address]="{address_1: patientData?.patient_address,
            city: patientData?.city, state: patientData?.state_name, zip: patientData.zip, type: 'patient'}"
          [buttonClickedSubject]="buttonClickedSubject" [elementId]="'add_card'"
          (cardResponse)="CatchStripeToken($event, addCardModal)" *ngIf="patientData" class="col-12"
          [show_save_card]="false"></app-generate-stripe-token>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-6 text-start">
            <button type="button" class="btn btn-outline-secondary" (click)="addCardModal.hide()">Cancel</button>
          </div>
          <div class="col-6 text-end">
            <button class="btn btn-primary" (click)="GetStripeToken('add_card')">Add</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>